/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { DeviceStatusCount } from "./DeviceStatusCount";
import {
    DeviceStatusCountFromJSON,
    DeviceStatusCountFromJSONTyped,
    DeviceStatusCountToJSON,
} from "./DeviceStatusCount";

/**
 *
 * @export
 * @interface GlobalDeviceStatusResponse
 */
export interface GlobalDeviceStatusResponse {
    /**
     *
     * @type {Array<DeviceStatusCount>}
     * @memberof GlobalDeviceStatusResponse
     */
    items?: Array<DeviceStatusCount>;
}

/**
 * Check if a given object implements the GlobalDeviceStatusResponse interface.
 */
export function instanceOfGlobalDeviceStatusResponse(
    value: object,
): value is GlobalDeviceStatusResponse {
    return true;
}

export function GlobalDeviceStatusResponseFromJSON(
    json: any,
): GlobalDeviceStatusResponse {
    return GlobalDeviceStatusResponseFromJSONTyped(json, false);
}

export function GlobalDeviceStatusResponseFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): GlobalDeviceStatusResponse {
    if (json == null) {
        return json;
    }
    return {
        items:
            json["items"] == null
                ? undefined
                : (json["items"] as Array<any>).map(DeviceStatusCountFromJSON),
    };
}

export function GlobalDeviceStatusResponseToJSON(
    value?: GlobalDeviceStatusResponse | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        items:
            value["items"] == null
                ? undefined
                : (value["items"] as Array<any>).map(DeviceStatusCountToJSON),
    };
}
